import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import {
	MatLegacyDialogModule as MatDialogModule,
	MatLegacyDialogRef as MatDialogRef
} from '@angular/material/legacy-dialog';

import { simpleTransitions } from '../../shared/animations/simple-transitions';

const READCOOKIEINFO = 'cookieInfoRead';
@Component({
	selector: 'copo-privacy-settings',
	templateUrl: './privacy-setting.component.html',
	animations: simpleTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	styleUrls: ['./privacy-setting.component.css'],
	standalone: true,
	// eslint-disable-next-line deprecation/deprecation
	imports: [TranslateModule, MatIconModule, MatButtonModule, MatDialogModule]

})
export class PrivacySettingComponent {
	constructor(
		// eslint-disable-next-line deprecation/deprecation
		private readonly dialogRef: MatDialogRef<PrivacySettingComponent>,
	) {}

	writeCookie(name: string, value: string, days: number) {
		const d = new Date();
		d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
		const expires = ';expires='.concat(d.toUTCString());
		const domain = document.location.host.endsWith('steeluser.com') ? ';domain=steeluser.com' : '';
		const samesite = ';samesite=Lax';
		// eslint-disable-next-line unicorn/no-document-cookie
		document.cookie = name.concat('=', value, expires, domain, ';path=/', samesite, ';secure');
	}

	closeDialog() {
		this.writeCookie(READCOOKIEINFO, 'true', 365);
		this.dialogRef.close();
	}
}
